const COUNTRIES = [
    {
        name: "Suisse",
        code: "CH",
        emoji: "🇨🇭",
        unicode: "U+1F1E8 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg",
        index: 227,
    },
    {
        name: "France",
        code: "FR",
        emoji: "🇫🇷",
        unicode: "U+1F1EB U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg",
        index: 71,
    },
    {
        name: "Italie",
        code: "IT",
        emoji: "🇮🇹",
        unicode: "U+1F1EE U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IT.svg",
        index: 123,
    },
    {
        name: "Afghanistan",
        code: "AF",
        emoji: "🇦🇫",
        unicode: "U+1F1E6 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AF.svg",
        index: 0,
    },
    {
        name: "Afrique du Sud",
        code: "ZA",
        emoji: "🇿🇦",
        unicode: "U+1F1FF U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZA.svg",
        index: 1,
    },
    {
        name: "Albanie",
        code: "AL",
        emoji: "🇦🇱",
        unicode: "U+1F1E6 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AL.svg",
        index: 2,
    },
    {
        name: "Algérie",
        code: "DZ",
        emoji: "🇩🇿",
        unicode: "U+1F1E9 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DZ.svg",
        index: 3,
    },
    {
        name: "Allemagne",
        code: "DE",
        emoji: "🇩🇪",
        unicode: "U+1F1E9 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg",
        index: 4,
    },
    {
        name: "Andorre",
        code: "AD",
        emoji: "🇦🇩",
        unicode: "U+1F1E6 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AD.svg",
        index: 5,
    },
    {
        name: "Angleterre",
        code: "UK",
        emoji: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
        unicode: "U+1F3F4 U+E0067 U+E0062 U+E0065 U+E006E U+E0067 U+E007F",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ENGLAND.svg",
        index: 6,
    },
    {
        name: "Angola",
        code: "AO",
        emoji: "🇦🇴",
        unicode: "U+1F1E6 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AO.svg",
        index: 7,
    },
    {
        name: "Anguilla",
        code: "AI",
        emoji: "🇦🇮",
        unicode: "U+1F1E6 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AI.svg",
        index: 8,
    },
    {
        name: "Antarctique",
        code: "AQ",
        emoji: "🇦🇶",
        unicode: "U+1F1E6 U+1F1F6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AQ.svg",
        index: 9,
    },
    {
        name: "Antigua-et-Barbuda",
        code: "AG",
        emoji: "🇦🇬",
        unicode: "U+1F1E6 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AG.svg",
        index: 10,
    },
    {
        name: "Arabie saoudite",
        code: "SA",
        emoji: "🇸🇦",
        unicode: "U+1F1F8 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SA.svg",
        index: 11,
    },
    {
        name: "Argentine",
        code: "AR",
        emoji: "🇦🇷",
        unicode: "U+1F1E6 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AR.svg",
        index: 12,
    },
    {
        name: "Arménie",
        code: "AM",
        emoji: "🇦🇲",
        unicode: "U+1F1E6 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AM.svg",
        index: 13,
    },
    {
        name: "Aruba",
        code: "AW",
        emoji: "🇦🇼",
        unicode: "U+1F1E6 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AW.svg",
        index: 14,
    },
    {
        name: "Australie",
        code: "AU",
        emoji: "🇦🇺",
        unicode: "U+1F1E6 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg",
        index: 15,
    },
    {
        name: "Autriche",
        code: "AT",
        emoji: "🇦🇹",
        unicode: "U+1F1E6 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg",
        index: 16,
    },
    {
        name: "Azerbaïdjan",
        code: "AZ",
        emoji: "🇦🇿",
        unicode: "U+1F1E6 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AZ.svg",
        index: 17,
    },
    {
        name: "Bahamas",
        code: "BS",
        emoji: "🇧🇸",
        unicode: "U+1F1E7 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BS.svg",
        index: 18,
    },
    {
        name: "Bahreïn",
        code: "BH",
        emoji: "🇧🇭",
        unicode: "U+1F1E7 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BH.svg",
        index: 19,
    },
    {
        name: "Bangladesh",
        code: "BD",
        emoji: "🇧🇩",
        unicode: "U+1F1E7 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BD.svg",
        index: 20,
    },
    {
        name: "Barbade",
        code: "BB",
        emoji: "🇧🇧",
        unicode: "U+1F1E7 U+1F1E7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BB.svg",
        index: 21,
    },
    {
        name: "Belgique",
        code: "BE",
        emoji: "🇧🇪",
        unicode: "U+1F1E7 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BE.svg",
        index: 22,
    },
    {
        name: "Belize",
        code: "BZ",
        emoji: "🇧🇿",
        unicode: "U+1F1E7 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BZ.svg",
        index: 23,
    },
    {
        name: "Bénin",
        code: "BJ",
        emoji: "🇧🇯",
        unicode: "U+1F1E7 U+1F1EF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BJ.svg",
        index: 24,
    },
    {
        name: "Bermudes",
        code: "BM",
        emoji: "🇧🇲",
        unicode: "U+1F1E7 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BM.svg",
        index: 25,
    },
    {
        name: "Bhoutan",
        code: "BT",
        emoji: "🇧🇹",
        unicode: "U+1F1E7 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BT.svg",
        index: 26,
    },
    {
        name: "Biélorussie",
        code: "BY",
        emoji: "🇧🇾",
        unicode: "U+1F1E7 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BY.svg",
        index: 27,
    },
    {
        name: "Bolivie",
        code: "BO",
        emoji: "🇧🇴",
        unicode: "U+1F1E7 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BO.svg",
        index: 28,
    },
    {
        name: "Bosnie-Herzégovine",
        code: "BA",
        emoji: "🇧🇦",
        unicode: "U+1F1E7 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BA.svg",
        index: 29,
    },
    {
        name: "Botswana",
        code: "BW",
        emoji: "🇧🇼",
        unicode: "U+1F1E7 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BW.svg",
        index: 30,
    },
    {
        name: "Brésil",
        code: "BR",
        emoji: "🇧🇷",
        unicode: "U+1F1E7 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BR.svg",
        index: 31,
    },
    {
        name: "Brunéi",
        code: "BN",
        emoji: "🇧🇳",
        unicode: "U+1F1E7 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BN.svg",
        index: 32,
    },
    {
        name: "Bulgarie",
        code: "BG",
        emoji: "🇧🇬",
        unicode: "U+1F1E7 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BG.svg",
        index: 33,
    },
    {
        name: "Burkina Faso",
        code: "BF",
        emoji: "🇧🇫",
        unicode: "U+1F1E7 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BF.svg",
        index: 34,
    },
    {
        name: "Burundi",
        code: "BI",
        emoji: "🇧🇮",
        unicode: "U+1F1E7 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BI.svg",
        index: 35,
    },
    {
        name: "Cambodge",
        code: "KH",
        emoji: "🇰🇭",
        unicode: "U+1F1F0 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KH.svg",
        index: 36,
    },
    {
        name: "Cameroun",
        code: "CM",
        emoji: "🇨🇲",
        unicode: "U+1F1E8 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CM.svg",
        index: 37,
    },
    {
        name: "Canada",
        code: "CA",
        emoji: "🇨🇦",
        unicode: "U+1F1E8 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CA.svg",
        index: 38,
    },
    {
        name: "Cap-Vert",
        code: "CV",
        emoji: "🇨🇻",
        unicode: "U+1F1E8 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CV.svg",
        index: 39,
    },
    {
        name: "Ceuta et Melilla",
        code: "EA",
        emoji: "🇪🇦",
        unicode: "U+1F1EA U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EA.svg",
        index: 40,
    },
    {
        name: "Chili",
        code: "CL",
        emoji: "🇨🇱",
        unicode: "U+1F1E8 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CL.svg",
        index: 41,
    },
    {
        name: "Chine",
        code: "CN",
        emoji: "🇨🇳",
        unicode: "U+1F1E8 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CN.svg",
        index: 42,
    },
    {
        name: "Chypre",
        code: "CY",
        emoji: "🇨🇾",
        unicode: "U+1F1E8 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CY.svg",
        index: 43,
    },
    {
        name: "Colombie",
        code: "CO",
        emoji: "🇨🇴",
        unicode: "U+1F1E8 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CO.svg",
        index: 44,
    },
    {
        name: "Comores",
        code: "KM",
        emoji: "🇰🇲",
        unicode: "U+1F1F0 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KM.svg",
        index: 45,
    },
    {
        name: "Congo-Brazzaville",
        code: "CG",
        emoji: "🇨🇬",
        unicode: "U+1F1E8 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CG.svg",
        index: 46,
    },
    {
        name: "Congo-Kinshasa",
        code: "CD",
        emoji: "🇨🇩",
        unicode: "U+1F1E8 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CD.svg",
        index: 47,
    },
    {
        name: "Corée du Nord",
        code: "KP",
        emoji: "🇰🇵",
        unicode: "U+1F1F0 U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KP.svg",
        index: 48,
    },
    {
        name: "Corée du Sud",
        code: "KR",
        emoji: "🇰🇷",
        unicode: "U+1F1F0 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KR.svg",
        index: 49,
    },
    {
        name: "Costa Rica",
        code: "CR",
        emoji: "🇨🇷",
        unicode: "U+1F1E8 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CR.svg",
        index: 50,
    },
    {
        name: "Côte d’Ivoire",
        code: "CI",
        emoji: "🇨🇮",
        unicode: "U+1F1E8 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CI.svg",
        index: 51,
    },
    {
        name: "Croatie",
        code: "HR",
        emoji: "🇭🇷",
        unicode: "U+1F1ED U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HR.svg",
        index: 52,
    },
    {
        name: "Cuba",
        code: "CU",
        emoji: "🇨🇺",
        unicode: "U+1F1E8 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CU.svg",
        index: 53,
    },
    {
        name: "Curaçao",
        code: "CW",
        emoji: "🇨🇼",
        unicode: "U+1F1E8 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CW.svg",
        index: 54,
    },
    {
        name: "Danemark",
        code: "DK",
        emoji: "🇩🇰",
        unicode: "U+1F1E9 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DK.svg",
        index: 55,
    },
    {
        name: "Diego Garcia",
        code: "DG",
        emoji: "🇩🇬",
        unicode: "U+1F1E9 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DG.svg",
        index: 56,
    },
    {
        name: "Djibouti",
        code: "DJ",
        emoji: "🇩🇯",
        unicode: "U+1F1E9 U+1F1EF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DJ.svg",
        index: 57,
    },
    {
        name: "Dominique",
        code: "DM",
        emoji: "🇩🇲",
        unicode: "U+1F1E9 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DM.svg",
        index: 58,
    },
    {
        name: "Écosse",
        code: "SCOTLAND",
        emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        unicode: "U+1F3F4 U+E0067 U+E0062 U+E0073 U+E0063 U+E0074 U+E007F",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SCOTLAND.svg",
        index: 59,
    },
    {
        name: "Égypte",
        code: "EG",
        emoji: "🇪🇬",
        unicode: "U+1F1EA U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EG.svg",
        index: 60,
    },
    {
        name: "Émirats arabes unis",
        code: "AE",
        emoji: "🇦🇪",
        unicode: "U+1F1E6 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AE.svg",
        index: 61,
    },
    {
        name: "Équateur",
        code: "EC",
        emoji: "🇪🇨",
        unicode: "U+1F1EA U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EC.svg",
        index: 62,
    },
    {
        name: "Érythrée",
        code: "ER",
        emoji: "🇪🇷",
        unicode: "U+1F1EA U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ER.svg",
        index: 63,
    },
    {
        name: "Espagne",
        code: "ES",
        emoji: "🇪🇸",
        unicode: "U+1F1EA U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg",
        index: 64,
    },
    {
        name: "Estonie",
        code: "EE",
        emoji: "🇪🇪",
        unicode: "U+1F1EA U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EE.svg",
        index: 65,
    },
    {
        name: "Eswatini",
        code: "SZ",
        emoji: "🇸🇿",
        unicode: "U+1F1F8 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SZ.svg",
        index: 66,
    },
    {
        name: "États-Unis",
        code: "US",
        emoji: "🇺🇸",
        unicode: "U+1F1FA U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg",
        index: 67,
    },
    {
        name: "Éthiopie",
        code: "ET",
        emoji: "🇪🇹",
        unicode: "U+1F1EA U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ET.svg",
        index: 68,
    },
    {
        name: "Fidji",
        code: "FJ",
        emoji: "🇫🇯",
        unicode: "U+1F1EB U+1F1EF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FJ.svg",
        index: 69,
    },
    {
        name: "Finlande",
        code: "FI",
        emoji: "🇫🇮",
        unicode: "U+1F1EB U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FI.svg",
        index: 70,
    },
    {
        name: "Gabon",
        code: "GA",
        emoji: "🇬🇦",
        unicode: "U+1F1EC U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GA.svg",
        index: 72,
    },
    {
        name: "Gambie",
        code: "GM",
        emoji: "🇬🇲",
        unicode: "U+1F1EC U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GM.svg",
        index: 73,
    },
    {
        name: "Géorgie",
        code: "GE",
        emoji: "🇬🇪",
        unicode: "U+1F1EC U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GE.svg",
        index: 74,
    },
    {
        name: "Géorgie du Sud-et-les-Îles Sandwich du Sud",
        code: "GS",
        emoji: "🇬🇸",
        unicode: "U+1F1EC U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GS.svg",
        index: 75,
    },
    {
        name: "Ghana",
        code: "GH",
        emoji: "🇬🇭",
        unicode: "U+1F1EC U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GH.svg",
        index: 76,
    },
    {
        name: "Gibraltar",
        code: "GI",
        emoji: "🇬🇮",
        unicode: "U+1F1EC U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GI.svg",
        index: 77,
    },
    {
        name: "Grèce",
        code: "GR",
        emoji: "🇬🇷",
        unicode: "U+1F1EC U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GR.svg",
        index: 78,
    },
    {
        name: "Grenade",
        code: "GD",
        emoji: "🇬🇩",
        unicode: "U+1F1EC U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GD.svg",
        index: 79,
    },
    {
        name: "Groenland",
        code: "GL",
        emoji: "🇬🇱",
        unicode: "U+1F1EC U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GL.svg",
        index: 80,
    },
    {
        name: "Guadeloupe",
        code: "GP",
        emoji: "🇬🇵",
        unicode: "U+1F1EC U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GP.svg",
        index: 81,
    },
    {
        name: "Guam",
        code: "GU",
        emoji: "🇬🇺",
        unicode: "U+1F1EC U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GU.svg",
        index: 82,
    },
    {
        name: "Guatemala",
        code: "GT",
        emoji: "🇬🇹",
        unicode: "U+1F1EC U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GT.svg",
        index: 83,
    },
    {
        name: "Guernesey",
        code: "GG",
        emoji: "🇬🇬",
        unicode: "U+1F1EC U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GG.svg",
        index: 84,
    },
    {
        name: "Guinée",
        code: "GN",
        emoji: "🇬🇳",
        unicode: "U+1F1EC U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GN.svg",
        index: 85,
    },
    {
        name: "Guinée équatoriale",
        code: "GQ",
        emoji: "🇬🇶",
        unicode: "U+1F1EC U+1F1F6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GQ.svg",
        index: 86,
    },
    {
        name: "Guinée-Bissau",
        code: "GW",
        emoji: "🇬🇼",
        unicode: "U+1F1EC U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GW.svg",
        index: 87,
    },
    {
        name: "Guyana",
        code: "GY",
        emoji: "🇬🇾",
        unicode: "U+1F1EC U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GY.svg",
        index: 88,
    },
    {
        name: "Guyane française",
        code: "GF",
        emoji: "🇬🇫",
        unicode: "U+1F1EC U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GF.svg",
        index: 89,
    },
    {
        name: "Haïti",
        code: "HT",
        emoji: "🇭🇹",
        unicode: "U+1F1ED U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HT.svg",
        index: 90,
    },
    {
        name: "Honduras",
        code: "HN",
        emoji: "🇭🇳",
        unicode: "U+1F1ED U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HN.svg",
        index: 91,
    },
    {
        name: "Hong Kong (RAS Chine)",
        code: "HK",
        emoji: "🇭🇰",
        unicode: "U+1F1ED U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HK.svg",
        index: 92,
    },
    {
        name: "Hongrie",
        code: "HU",
        emoji: "🇭🇺",
        unicode: "U+1F1ED U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HU.svg",
        index: 93,
    },
    {
        name: "Île Bouvet",
        code: "BV",
        emoji: "🇧🇻",
        unicode: "U+1F1E7 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BV.svg",
        index: 94,
    },
    {
        name: "Île Christmas",
        code: "CX",
        emoji: "🇨🇽",
        unicode: "U+1F1E8 U+1F1FD",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CX.svg",
        index: 95,
    },
    {
        name: "Île Clipperton",
        code: "CP",
        emoji: "🇨🇵",
        unicode: "U+1F1E8 U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CP.svg",
        index: 96,
    },
    {
        name: "Île de l'Ascension",
        code: "AC",
        emoji: "🇦🇨",
        unicode: "U+1F1E6 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AC.svg",
        index: 97,
    },
    {
        name: "Île de Man",
        code: "IM",
        emoji: "🇮🇲",
        unicode: "U+1F1EE U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IM.svg",
        index: 98,
    },
    {
        name: "Île Norfolk",
        code: "NF",
        emoji: "🇳🇫",
        unicode: "U+1F1F3 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NF.svg",
        index: 99,
    },
    {
        name: "Îles Åland",
        code: "AX",
        emoji: "🇦🇽",
        unicode: "U+1F1E6 U+1F1FD",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AX.svg",
        index: 100,
    },
    {
        name: "Îles Caïmans",
        code: "KY",
        emoji: "🇰🇾",
        unicode: "U+1F1F0 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KY.svg",
        index: 101,
    },
    {
        name: "Îles Canaries",
        code: "IC",
        emoji: "🇮🇨",
        unicode: "U+1F1EE U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IC.svg",
        index: 102,
    },
    {
        name: "Îles Cocos (Keeling)",
        code: "CC",
        emoji: "🇨🇨",
        unicode: "U+1F1E8 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CC.svg",
        index: 103,
    },
    {
        name: "Îles Cook",
        code: "CK",
        emoji: "🇨🇰",
        unicode: "U+1F1E8 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CK.svg",
        index: 104,
    },
    {
        name: "Îles Féroé",
        code: "FO",
        emoji: "🇫🇴",
        unicode: "U+1F1EB U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FO.svg",
        index: 105,
    },
    {
        name: "Îles Heard-et-MacDonald",
        code: "HM",
        emoji: "🇭🇲",
        unicode: "U+1F1ED U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HM.svg",
        index: 106,
    },
    {
        name: "Îles Malouines",
        code: "FK",
        emoji: "🇫🇰",
        unicode: "U+1F1EB U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FK.svg",
        index: 107,
    },
    {
        name: "Îles Mariannes du Nord",
        code: "MP",
        emoji: "🇲🇵",
        unicode: "U+1F1F2 U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MP.svg",
        index: 108,
    },
    {
        name: "Îles Marshall",
        code: "MH",
        emoji: "🇲🇭",
        unicode: "U+1F1F2 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MH.svg",
        index: 109,
    },
    {
        name: "Îles mineures éloignées des États-Unis",
        code: "UM",
        emoji: "🇺🇲",
        unicode: "U+1F1FA U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UM.svg",
        index: 110,
    },
    {
        name: "Îles Pitcairn",
        code: "PN",
        emoji: "🇵🇳",
        unicode: "U+1F1F5 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PN.svg",
        index: 111,
    },
    {
        name: "Îles Salomon",
        code: "SB",
        emoji: "🇸🇧",
        unicode: "U+1F1F8 U+1F1E7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SB.svg",
        index: 112,
    },
    {
        name: "Îles Turques-et-Caïques",
        code: "TC",
        emoji: "🇹🇨",
        unicode: "U+1F1F9 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TC.svg",
        index: 113,
    },
    {
        name: "Îles Vierges américaines",
        code: "VI",
        emoji: "🇻🇮",
        unicode: "U+1F1FB U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VI.svg",
        index: 114,
    },
    {
        name: "Îles Vierges britanniques",
        code: "VG",
        emoji: "🇻🇬",
        unicode: "U+1F1FB U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VG.svg",
        index: 115,
    },
    {
        name: "Inde",
        code: "IN",
        emoji: "🇮🇳",
        unicode: "U+1F1EE U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg",
        index: 116,
    },
    {
        name: "Indonésie",
        code: "ID",
        emoji: "🇮🇩",
        unicode: "U+1F1EE U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ID.svg",
        index: 117,
    },
    {
        name: "Irak",
        code: "IQ",
        emoji: "🇮🇶",
        unicode: "U+1F1EE U+1F1F6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IQ.svg",
        index: 118,
    },
    {
        name: "Iran",
        code: "IR",
        emoji: "🇮🇷",
        unicode: "U+1F1EE U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IR.svg",
        index: 119,
    },
    {
        name: "Irlande",
        code: "IE",
        emoji: "🇮🇪",
        unicode: "U+1F1EE U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IE.svg",
        index: 120,
    },
    {
        name: "Islande",
        code: "IS",
        emoji: "🇮🇸",
        unicode: "U+1F1EE U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IS.svg",
        index: 121,
    },
    {
        name: "Israël",
        code: "IL",
        emoji: "🇮🇱",
        unicode: "U+1F1EE U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IL.svg",
        index: 122,
    },
    {
        name: "Jamaïque",
        code: "JM",
        emoji: "🇯🇲",
        unicode: "U+1F1EF U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JM.svg",
        index: 124,
    },
    {
        name: "Japon",
        code: "JP",
        emoji: "🇯🇵",
        unicode: "U+1F1EF U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JP.svg",
        index: 125,
    },
    {
        name: "Jersey",
        code: "JE",
        emoji: "🇯🇪",
        unicode: "U+1F1EF U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JE.svg",
        index: 126,
    },
    {
        name: "Jordanie",
        code: "JO",
        emoji: "🇯🇴",
        unicode: "U+1F1EF U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JO.svg",
        index: 127,
    },
    {
        name: "Kazakhstan",
        code: "KZ",
        emoji: "🇰🇿",
        unicode: "U+1F1F0 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KZ.svg",
        index: 128,
    },
    {
        name: "Kenya",
        code: "KE",
        emoji: "🇰🇪",
        unicode: "U+1F1F0 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KE.svg",
        index: 129,
    },
    {
        name: "Kirghizistan",
        code: "KG",
        emoji: "🇰🇬",
        unicode: "U+1F1F0 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KG.svg",
        index: 130,
    },
    {
        name: "Kiribati",
        code: "KI",
        emoji: "🇰🇮",
        unicode: "U+1F1F0 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KI.svg",
        index: 131,
    },
    {
        name: "Kosovo",
        code: "XK",
        emoji: "🇽🇰",
        unicode: "U+1F1FD U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/XK.svg",
        index: 132,
    },
    {
        name: "Koweït",
        code: "KW",
        emoji: "🇰🇼",
        unicode: "U+1F1F0 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KW.svg",
        index: 133,
    },
    {
        name: "La Réunion",
        code: "RE",
        emoji: "🇷🇪",
        unicode: "U+1F1F7 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RE.svg",
        index: 134,
    },
    {
        name: "Laos",
        code: "LA",
        emoji: "🇱🇦",
        unicode: "U+1F1F1 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LA.svg",
        index: 135,
    },
    {
        name: "Lesotho",
        code: "LS",
        emoji: "🇱🇸",
        unicode: "U+1F1F1 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LS.svg",
        index: 136,
    },
    {
        name: "Lettonie",
        code: "LV",
        emoji: "🇱🇻",
        unicode: "U+1F1F1 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LV.svg",
        index: 137,
    },
    {
        name: "Liban",
        code: "LB",
        emoji: "🇱🇧",
        unicode: "U+1F1F1 U+1F1E7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LB.svg",
        index: 138,
    },
    {
        name: "Liberia",
        code: "LR",
        emoji: "🇱🇷",
        unicode: "U+1F1F1 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LR.svg",
        index: 139,
    },
    {
        name: "Libye",
        code: "LY",
        emoji: "🇱🇾",
        unicode: "U+1F1F1 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LY.svg",
        index: 140,
    },
    {
        name: "Liechtenstein",
        code: "LI",
        emoji: "🇱🇮",
        unicode: "U+1F1F1 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg",
        index: 141,
    },
    {
        name: "Lituanie",
        code: "LT",
        emoji: "🇱🇹",
        unicode: "U+1F1F1 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LT.svg",
        index: 142,
    },
    {
        name: "Luxembourg",
        code: "LU",
        emoji: "🇱🇺",
        unicode: "U+1F1F1 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LU.svg",
        index: 143,
    },
    {
        name: "Macao (RAS Chine)",
        code: "MO",
        emoji: "🇲🇴",
        unicode: "U+1F1F2 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MO.svg",
        index: 144,
    },
    {
        name: "Macédoine du Nord",
        code: "MK",
        emoji: "🇲🇰",
        unicode: "U+1F1F2 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MK.svg",
        index: 145,
    },
    {
        name: "Madagascar",
        code: "MG",
        emoji: "🇲🇬",
        unicode: "U+1F1F2 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MG.svg",
        index: 146,
    },
    {
        name: "Malaisie",
        code: "MY",
        emoji: "🇲🇾",
        unicode: "U+1F1F2 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MY.svg",
        index: 147,
    },
    {
        name: "Malawi",
        code: "MW",
        emoji: "🇲🇼",
        unicode: "U+1F1F2 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MW.svg",
        index: 148,
    },
    {
        name: "Maldives",
        code: "MV",
        emoji: "🇲🇻",
        unicode: "U+1F1F2 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MV.svg",
        index: 149,
    },
    {
        name: "Mali",
        code: "ML",
        emoji: "🇲🇱",
        unicode: "U+1F1F2 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ML.svg",
        index: 150,
    },
    {
        name: "Malte",
        code: "MT",
        emoji: "🇲🇹",
        unicode: "U+1F1F2 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MT.svg",
        index: 151,
    },
    {
        name: "Maroc",
        code: "MA",
        emoji: "🇲🇦",
        unicode: "U+1F1F2 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MA.svg",
        index: 152,
    },
    {
        name: "Martinique",
        code: "MQ",
        emoji: "🇲🇶",
        unicode: "U+1F1F2 U+1F1F6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MQ.svg",
        index: 153,
    },
    {
        name: "Maurice",
        code: "MU",
        emoji: "🇲🇺",
        unicode: "U+1F1F2 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MU.svg",
        index: 154,
    },
    {
        name: "Mauritanie",
        code: "MR",
        emoji: "🇲🇷",
        unicode: "U+1F1F2 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MR.svg",
        index: 155,
    },
    {
        name: "Mayotte",
        code: "YT",
        emoji: "🇾🇹",
        unicode: "U+1F1FE U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YT.svg",
        index: 156,
    },
    {
        name: "Mexique",
        code: "MX",
        emoji: "🇲🇽",
        unicode: "U+1F1F2 U+1F1FD",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MX.svg",
        index: 157,
    },
    {
        name: "Micronésie",
        code: "FM",
        emoji: "🇫🇲",
        unicode: "U+1F1EB U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FM.svg",
        index: 158,
    },
    {
        name: "Moldavie",
        code: "MD",
        emoji: "🇲🇩",
        unicode: "U+1F1F2 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MD.svg",
        index: 159,
    },
    {
        name: "Monaco",
        code: "MC",
        emoji: "🇲🇨",
        unicode: "U+1F1F2 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MC.svg",
        index: 160,
    },
    {
        name: "Mongolie",
        code: "MN",
        emoji: "🇲🇳",
        unicode: "U+1F1F2 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MN.svg",
        index: 161,
    },
    {
        name: "Monténégro",
        code: "ME",
        emoji: "🇲🇪",
        unicode: "U+1F1F2 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ME.svg",
        index: 162,
    },
    {
        name: "Montserrat",
        code: "MS",
        emoji: "🇲🇸",
        unicode: "U+1F1F2 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MS.svg",
        index: 163,
    },
    {
        name: "Mozambique",
        code: "MZ",
        emoji: "🇲🇿",
        unicode: "U+1F1F2 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MZ.svg",
        index: 164,
    },
    {
        name: "Myanmar (Birmanie)",
        code: "MM",
        emoji: "🇲🇲",
        unicode: "U+1F1F2 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MM.svg",
        index: 165,
    },
    {
        name: "Namibie",
        code: "NA",
        emoji: "🇳🇦",
        unicode: "U+1F1F3 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NA.svg",
        index: 166,
    },
    {
        name: "Nations unies",
        code: "UN",
        emoji: "🇺🇳",
        unicode: "U+1F1FA U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UN.svg",
        index: 167,
    },
    {
        name: "Nauru",
        code: "NR",
        emoji: "🇳🇷",
        unicode: "U+1F1F3 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NR.svg",
        index: 168,
    },
    {
        name: "Népal",
        code: "NP",
        emoji: "🇳🇵",
        unicode: "U+1F1F3 U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NP.svg",
        index: 169,
    },
    {
        name: "Nicaragua",
        code: "NI",
        emoji: "🇳🇮",
        unicode: "U+1F1F3 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NI.svg",
        index: 170,
    },
    {
        name: "Niger",
        code: "NE",
        emoji: "🇳🇪",
        unicode: "U+1F1F3 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NE.svg",
        index: 171,
    },
    {
        name: "Nigéria",
        code: "NG",
        emoji: "🇳🇬",
        unicode: "U+1F1F3 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NG.svg",
        index: 172,
    },
    {
        name: "Niue",
        code: "NU",
        emoji: "🇳🇺",
        unicode: "U+1F1F3 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NU.svg",
        index: 173,
    },
    {
        name: "Norvège",
        code: "NO",
        emoji: "🇳🇴",
        unicode: "U+1F1F3 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NO.svg",
        index: 174,
    },
    {
        name: "Nouvelle-Calédonie",
        code: "NC",
        emoji: "🇳🇨",
        unicode: "U+1F1F3 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NC.svg",
        index: 175,
    },
    {
        name: "Nouvelle-Zélande",
        code: "NZ",
        emoji: "🇳🇿",
        unicode: "U+1F1F3 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NZ.svg",
        index: 176,
    },
    {
        name: "Oman",
        code: "OM",
        emoji: "🇴🇲",
        unicode: "U+1F1F4 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/OM.svg",
        index: 177,
    },
    {
        name: "Ouganda",
        code: "UG",
        emoji: "🇺🇬",
        unicode: "U+1F1FA U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UG.svg",
        index: 178,
    },
    {
        name: "Ouzbékistan",
        code: "UZ",
        emoji: "🇺🇿",
        unicode: "U+1F1FA U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UZ.svg",
        index: 179,
    },
    {
        name: "Pakistan",
        code: "PK",
        emoji: "🇵🇰",
        unicode: "U+1F1F5 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PK.svg",
        index: 180,
    },
    {
        name: "Palaos",
        code: "PW",
        emoji: "🇵🇼",
        unicode: "U+1F1F5 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PW.svg",
        index: 181,
    },
    {
        name: "Panama",
        code: "PA",
        emoji: "🇵🇦",
        unicode: "U+1F1F5 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PA.svg",
        index: 182,
    },
    {
        name: "Papouasie-Nouvelle-Guinée",
        code: "PG",
        emoji: "🇵🇬",
        unicode: "U+1F1F5 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PG.svg",
        index: 183,
    },
    {
        name: "Paraguay",
        code: "PY",
        emoji: "🇵🇾",
        unicode: "U+1F1F5 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PY.svg",
        index: 184,
    },
    {
        name: "Pays de Galles",
        code: "WALES",
        emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
        unicode: "U+1F3F4 U+E0067 U+E0062 U+E0077 U+E006C U+E0073 U+E007F",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WALES.svg",
        index: 185,
    },
    {
        name: "Pays-Bas",
        code: "NL",
        emoji: "🇳🇱",
        unicode: "U+1F1F3 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NL.svg",
        index: 186,
    },
    {
        name: "Pays-Bas caribéens",
        code: "BQ",
        emoji: "🇧🇶",
        unicode: "U+1F1E7 U+1F1F6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BQ.svg",
        index: 187,
    },
    {
        name: "Pérou",
        code: "PE",
        emoji: "🇵🇪",
        unicode: "U+1F1F5 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PE.svg",
        index: 188,
    },
    {
        name: "Philippines",
        code: "PH",
        emoji: "🇵🇭",
        unicode: "U+1F1F5 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PH.svg",
        index: 189,
    },
    {
        name: "Pologne",
        code: "PL",
        emoji: "🇵🇱",
        unicode: "U+1F1F5 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PL.svg",
        index: 190,
    },
    {
        name: "Polynésie française",
        code: "PF",
        emoji: "🇵🇫",
        unicode: "U+1F1F5 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PF.svg",
        index: 191,
    },
    {
        name: "Porto Rico",
        code: "PR",
        emoji: "🇵🇷",
        unicode: "U+1F1F5 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PR.svg",
        index: 192,
    },
    {
        name: "Portugal",
        code: "PT",
        emoji: "🇵🇹",
        unicode: "U+1F1F5 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PT.svg",
        index: 193,
    },
    {
        name: "Qatar",
        code: "QA",
        emoji: "🇶🇦",
        unicode: "U+1F1F6 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/QA.svg",
        index: 194,
    },
    {
        name: "République centrafricaine",
        code: "CF",
        emoji: "🇨🇫",
        unicode: "U+1F1E8 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CF.svg",
        index: 195,
    },
    {
        name: "République dominicaine",
        code: "DO",
        emoji: "🇩🇴",
        unicode: "U+1F1E9 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DO.svg",
        index: 196,
    },
    {
        name: "Roumanie",
        code: "RO",
        emoji: "🇷🇴",
        unicode: "U+1F1F7 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RO.svg",
        index: 197,
    },
    {
        name: "Royaume-Uni",
        code: "GB",
        emoji: "🇬🇧",
        unicode: "U+1F1EC U+1F1E7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg",
        index: 198,
    },
    {
        name: "Russie",
        code: "RU",
        emoji: "🇷🇺",
        unicode: "U+1F1F7 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RU.svg",
        index: 199,
    },
    {
        name: "Rwanda",
        code: "RW",
        emoji: "🇷🇼",
        unicode: "U+1F1F7 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RW.svg",
        index: 200,
    },
    {
        name: "Sahara occidental",
        code: "EH",
        emoji: "🇪🇭",
        unicode: "U+1F1EA U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EH.svg",
        index: 201,
    },
    {
        name: "Saint-Barthélemy",
        code: "BL",
        emoji: "🇧🇱",
        unicode: "U+1F1E7 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BL.svg",
        index: 202,
    },
    {
        name: "Saint-Christophe-et-Niévès",
        code: "KN",
        emoji: "🇰🇳",
        unicode: "U+1F1F0 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KN.svg",
        index: 203,
    },
    {
        name: "Saint-Marin",
        code: "SM",
        emoji: "🇸🇲",
        unicode: "U+1F1F8 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SM.svg",
        index: 204,
    },
    {
        name: "Saint-Martin (partie française)",
        code: "MF",
        emoji: "🇲🇫",
        unicode: "U+1F1F2 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MF.svg",
        index: 205,
    },
    {
        name: "Saint-Martin (partie néerlandaise)",
        code: "SX",
        emoji: "🇸🇽",
        unicode: "U+1F1F8 U+1F1FD",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SX.svg",
        index: 206,
    },
    {
        name: "Saint-Pierre-et-Miquelon",
        code: "PM",
        emoji: "🇵🇲",
        unicode: "U+1F1F5 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PM.svg",
        index: 207,
    },
    {
        name: "Saint-Vincent-et-les-Grenadines",
        code: "VC",
        emoji: "🇻🇨",
        unicode: "U+1F1FB U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VC.svg",
        index: 208,
    },
    {
        name: "Sainte-Hélène",
        code: "SH",
        emoji: "🇸🇭",
        unicode: "U+1F1F8 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SH.svg",
        index: 209,
    },
    {
        name: "Sainte-Lucie",
        code: "LC",
        emoji: "🇱🇨",
        unicode: "U+1F1F1 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LC.svg",
        index: 210,
    },
    {
        name: "Salvador",
        code: "SV",
        emoji: "🇸🇻",
        unicode: "U+1F1F8 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SV.svg",
        index: 211,
    },
    {
        name: "Samoa",
        code: "WS",
        emoji: "🇼🇸",
        unicode: "U+1F1FC U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WS.svg",
        index: 212,
    },
    {
        name: "Samoa américaines",
        code: "AS",
        emoji: "🇦🇸",
        unicode: "U+1F1E6 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AS.svg",
        index: 213,
    },
    {
        name: "Sao Tomé-et-Principe",
        code: "ST",
        emoji: "🇸🇹",
        unicode: "U+1F1F8 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ST.svg",
        index: 214,
    },
    {
        name: "Sénégal",
        code: "SN",
        emoji: "🇸🇳",
        unicode: "U+1F1F8 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SN.svg",
        index: 215,
    },
    {
        name: "Serbie",
        code: "RS",
        emoji: "🇷🇸",
        unicode: "U+1F1F7 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RS.svg",
        index: 216,
    },
    {
        name: "Seychelles",
        code: "SC",
        emoji: "🇸🇨",
        unicode: "U+1F1F8 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SC.svg",
        index: 217,
    },
    {
        name: "Sierra Leone",
        code: "SL",
        emoji: "🇸🇱",
        unicode: "U+1F1F8 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SL.svg",
        index: 218,
    },
    {
        name: "Singapour",
        code: "SG",
        emoji: "🇸🇬",
        unicode: "U+1F1F8 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SG.svg",
        index: 219,
    },
    {
        name: "Slovaquie",
        code: "SK",
        emoji: "🇸🇰",
        unicode: "U+1F1F8 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SK.svg",
        index: 220,
    },
    {
        name: "Slovénie",
        code: "SI",
        emoji: "🇸🇮",
        unicode: "U+1F1F8 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SI.svg",
        index: 221,
    },
    {
        name: "Somalie",
        code: "SO",
        emoji: "🇸🇴",
        unicode: "U+1F1F8 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SO.svg",
        index: 222,
    },
    {
        name: "Soudan",
        code: "SD",
        emoji: "🇸🇩",
        unicode: "U+1F1F8 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SD.svg",
        index: 223,
    },
    {
        name: "Soudan du Sud",
        code: "SS",
        emoji: "🇸🇸",
        unicode: "U+1F1F8 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SS.svg",
        index: 224,
    },
    {
        name: "Sri Lanka",
        code: "LK",
        emoji: "🇱🇰",
        unicode: "U+1F1F1 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LK.svg",
        index: 225,
    },
    {
        name: "Suède",
        code: "SE",
        emoji: "🇸🇪",
        unicode: "U+1F1F8 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SE.svg",
        index: 226,
    },
    {
        name: "Suriname",
        code: "SR",
        emoji: "🇸🇷",
        unicode: "U+1F1F8 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SR.svg",
        index: 228,
    },
    {
        name: "Svalbard et Jan Mayen",
        code: "SJ",
        emoji: "🇸🇯",
        unicode: "U+1F1F8 U+1F1EF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SJ.svg",
        index: 229,
    },
    {
        name: "Syrie",
        code: "SY",
        emoji: "🇸🇾",
        unicode: "U+1F1F8 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SY.svg",
        index: 230,
    },
    {
        name: "Tadjikistan",
        code: "TJ",
        emoji: "🇹🇯",
        unicode: "U+1F1F9 U+1F1EF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TJ.svg",
        index: 231,
    },
    {
        name: "Taïwan",
        code: "TW",
        emoji: "🇹🇼",
        unicode: "U+1F1F9 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TW.svg",
        index: 232,
    },
    {
        name: "Tanzanie",
        code: "TZ",
        emoji: "🇹🇿",
        unicode: "U+1F1F9 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TZ.svg",
        index: 233,
    },
    {
        name: "Tchad",
        code: "TD",
        emoji: "🇹🇩",
        unicode: "U+1F1F9 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TD.svg",
        index: 234,
    },
    {
        name: "Tchéquie",
        code: "CZ",
        emoji: "🇨🇿",
        unicode: "U+1F1E8 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CZ.svg",
        index: 235,
    },
    {
        name: "Terres australes françaises",
        code: "TF",
        emoji: "🇹🇫",
        unicode: "U+1F1F9 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TF.svg",
        index: 236,
    },
    {
        name: "Territoire britannique de l'océan Indien",
        code: "IO",
        emoji: "🇮🇴",
        unicode: "U+1F1EE U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IO.svg",
        index: 237,
    },
    {
        name: "Territoires palestiniens",
        code: "PS",
        emoji: "🇵🇸",
        unicode: "U+1F1F5 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PS.svg",
        index: 238,
    },
    {
        name: "Thaïlande",
        code: "TH",
        emoji: "🇹🇭",
        unicode: "U+1F1F9 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TH.svg",
        index: 239,
    },
    {
        name: "Timor oriental",
        code: "TL",
        emoji: "🇹🇱",
        unicode: "U+1F1F9 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TL.svg",
        index: 240,
    },
    {
        name: "Togo",
        code: "TG",
        emoji: "🇹🇬",
        unicode: "U+1F1F9 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TG.svg",
        index: 241,
    },
    {
        name: "Tokelau",
        code: "TK",
        emoji: "🇹🇰",
        unicode: "U+1F1F9 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TK.svg",
        index: 242,
    },
    {
        name: "Tonga",
        code: "TO",
        emoji: "🇹🇴",
        unicode: "U+1F1F9 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TO.svg",
        index: 243,
    },
    {
        name: "Trinité-et-Tobago",
        code: "TT",
        emoji: "🇹🇹",
        unicode: "U+1F1F9 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TT.svg",
        index: 244,
    },
    {
        name: "Tristan da Cunha",
        code: "TA",
        emoji: "🇹🇦",
        unicode: "U+1F1F9 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TA.svg",
        index: 245,
    },
    {
        name: "Tunisie",
        code: "TN",
        emoji: "🇹🇳",
        unicode: "U+1F1F9 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TN.svg",
        index: 246,
    },
    {
        name: "Turkménistan",
        code: "TM",
        emoji: "🇹🇲",
        unicode: "U+1F1F9 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TM.svg",
        index: 247,
    },
    {
        name: "Turquie",
        code: "TR",
        emoji: "🇹🇷",
        unicode: "U+1F1F9 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TR.svg",
        index: 248,
    },
    {
        name: "Tuvalu",
        code: "TV",
        emoji: "🇹🇻",
        unicode: "U+1F1F9 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TV.svg",
        index: 249,
    },
    {
        name: "Ukraine",
        code: "UA",
        emoji: "🇺🇦",
        unicode: "U+1F1FA U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UA.svg",
        index: 250,
    },
    {
        name: "Uruguay",
        code: "UY",
        emoji: "🇺🇾",
        unicode: "U+1F1FA U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UY.svg",
        index: 251,
    },
    {
        name: "Vanuatu",
        code: "VU",
        emoji: "🇻🇺",
        unicode: "U+1F1FB U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VU.svg",
        index: 252,
    },
    {
        name: "Vatican",
        code: "VA",
        emoji: "🇻🇦",
        unicode: "U+1F1FB U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VA.svg",
        index: 253,
    },
    {
        name: "Venezuela",
        code: "VE",
        emoji: "🇻🇪",
        unicode: "U+1F1FB U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VE.svg",
        index: 254,
    },
    {
        name: "Viêt Nam",
        code: "VN",
        emoji: "🇻🇳",
        unicode: "U+1F1FB U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VN.svg",
        index: 255,
    },
    {
        name: "Wallis-et-Futuna",
        code: "WF",
        emoji: "🇼🇫",
        unicode: "U+1F1FC U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WF.svg",
        index: 256,
    },
    {
        name: "Yémen",
        code: "YE",
        emoji: "🇾🇪",
        unicode: "U+1F1FE U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YE.svg",
        index: 257,
    },
    {
        name: "Zambie",
        code: "ZM",
        emoji: "🇿🇲",
        unicode: "U+1F1FF U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZM.svg",
        index: 258,
    },
    {
        name: "Zimbabwe",
        code: "ZW",
        emoji: "🇿🇼",
        unicode: "U+1F1FF U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZW.svg",
        index: 259,
    },
];

export const DROPDOWN_COUNTRIES_FORMAT = () => {
    return COUNTRIES.map((el) => {
        return {
            index: el.index,
            key: el.index,
            header: el.name,
            image: el.image,
            content: "",
            detail: el,
        };
    });
};

export const getCountryNameByCode = (code = "ch") => {
    return COUNTRIES.find((el) => el?.code.toLowerCase() === code.toLowerCase())
        ?.name;
};

export const getDataCountryByCode = (code) => {
    const country = COUNTRIES?.find(
        (el) => el?.code?.toLowerCase() === code?.toLowerCase()
    );
    return {
        index: country?.index,
        header: country?.name,
        image: country?.image,
        content: "",
        detail: country,
    };
};
